import { useEffect, useState } from "react";

export const useDebounce = (value: any, delay = 400) => {
  const [debouncevalue, SetDebounceValue] = useState<any>(value);
  
  useEffect(() => {
    const timeout = setTimeout(() => {
      SetDebounceValue(value);
    }, delay);
    return () => clearTimeout(timeout);
  }, [value, delay]);
  
  return debouncevalue;
};
